import React, { useEffect, useRef, useState } from "react";
import "./SpecialOffer.css";

export default function SpecialOffer() {
  // Pexels spa image
  const BG = "./about2.webp";

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="offer"
      aria-label="Special offer banner"
    >
      {/* Background image container */}
      <div 
        className="offer__background"
        style={{ backgroundImage: `url("${BG}")` }}
        aria-hidden="true"
      />
      
      {/* Multi-layer overlays for depth */}
      <div className="offer__overlay" aria-hidden="true" />
      <div className="offer__gradient-overlay" aria-hidden="true" />
      <div className="offer__vignette" aria-hidden="true" />
      
      {/* Animated particles */}
      <div className="offer__particles" aria-hidden="true">
        <div className="offer__particle offer__particle--1"></div>
        <div className="offer__particle offer__particle--2"></div>
        <div className="offer__particle offer__particle--3"></div>
        <div className="offer__particle offer__particle--4"></div>
      </div>

      <div className={`offer__content ${isVisible ? 'is-visible' : ''}`}>
        {/* Kicker with ornament */}
        <div className="offer__kicker-container">
          <div className="offer__ornament" aria-hidden="true">
            <div className="offer__ornament-line"></div>
            <div className="offer__ornament-dot"></div>
            <div className="offer__ornament-line"></div>
          </div>
 
        </div>

        {/* Main title */}
        <h2 className="offer__title">
          <span className="offer__title-line">YOU OWE YOURSELF</span>
          <span className="offer__title-line offer__title-line--accent">THIS MOMENT</span>
        </h2>

        {/* Enhanced rule with animation */}
        <div className="offer__rule" aria-hidden="true">
          <div className="offer__rule-line"></div>
          <div className="offer__rule-glyph">
            <div className="offer__glyph">✦</div>
          </div>
          <div className="offer__rule-line"></div>
        </div>

        {/* CTA Button with enhancements */}
        <div className="offer__cta-container">
          <a href="https://mysite.vagaro.com/apeacefulretreat" className="offer__cta" aria-label="Make an appointment">
            <span className="offer__cta-text">MAKE AN APPOINTMENT</span>
            <div className="offer__cta-icon">
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M5 12h14m-7-7l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="offer__cta-shine"></div>
          </a>
        </div>
      </div>
    </section>
  );
}